import React, { FC, useContext, useMemo } from 'react';
import { TAX_INVOICE } from '../../Checkout.page';
import { Field, useFormState } from 'react-final-form';
import InputField from 'components/InputField';
import validations from 'validations';
import { useTranslation } from 'react-i18next';
import { CURRENCIES } from 'models/DealRoom';
import { PAYMENT_OPTION } from 'models/Listing';
import { checkIsNzLocation } from 'router/subrouters/ListingCreationWizard/utils';
import ListingContext from '../../../../providers/Listing/Listing.context';
import PatchListingContext from 'router/subrouters/ListingCreationWizard/providers/PatchListing/PatchListing.context';

import './TaxInvoice.styles.scss';

const TaxInvoice: FC = () => {
  const { t } = useTranslation();

  const {
    values: { paymentOption },
  } = useFormState();
  const {
    listing: { locationState, currency },
  } = useContext(ListingContext);
  const { patchListingValue } = useContext(PatchListingContext);

  const isNzLocation = useMemo(
    () => checkIsNzLocation(locationState) || currency === CURRENCIES.NZD,
    [currency, locationState],
  );

  if (paymentOption === PAYMENT_OPTION.INVOICE) return null;

  return (
    <div className="tax-invoice white-panel">
      <div className="tax-invoice__header">
        {t('taxInvoice')}
        <p>{t('inputYourDetailsForATaxReceipt')}</p>
      </div>

      <Field
        name={`${TAX_INVOICE}.name`}
        component={InputField}
        label={t('yourName')}
        customOnBlur={(e: React.FocusEvent<HTMLTextAreaElement>) => {
          patchListingValue({
            [TAX_INVOICE]: { name: e.target.value || null },
          });
        }}
      />
      <Field
        name={`${TAX_INVOICE}.legalEntity`}
        component={InputField}
        label={t('legalEntity')}
        customOnBlur={(e: React.FocusEvent<HTMLTextAreaElement>) => {
          patchListingValue({
            [TAX_INVOICE]: { legalEntity: e.target.value || null },
          });
        }}
      />

      {isNzLocation ? (
        <Field
          name={`${TAX_INVOICE}.NZBN`}
          component={InputField}
          label={t('NZBN')}
          validate={validations.nzbnField(t('nzbnInvalid'))}
          customOnBlur={(e: React.FocusEvent<HTMLTextAreaElement>) => {
            patchListingValue({
              [TAX_INVOICE]: { NZBN: e.target.value || null },
            });
          }}
        />
      ) : (
        <Field
          name={`${TAX_INVOICE}.ABN`}
          component={InputField}
          label={t('ABN')}
          validate={validations.abnField(t('abnInvalid'))}
          customOnBlur={(e: React.FocusEvent<HTMLTextAreaElement>) => {
            patchListingValue({
              [TAX_INVOICE]: { ABN: e.target.value || null },
            });
          }}
        />
      )}

      <Field
        name={`${TAX_INVOICE}.address`}
        component={InputField}
        label={t('address')}
        customOnBlur={(e: React.FocusEvent<HTMLTextAreaElement>) => {
          patchListingValue({
            [TAX_INVOICE]: { address: e.target.value || null },
          });
        }}
      />
    </div>
  );
};

export default TaxInvoice;
